import { useSearchParams, Link } from 'react-router-dom';

export default function ConsentErrorPage() {
  const [searchParams] = useSearchParams();
  const reason = searchParams.get('reason') || 'Unknown error';

  return (
    <div className="max-w-lg mx-auto space-y-6 py-8">
      <div className="bg-white rounded-xl shadow-sm border border-red-200 p-8 text-center space-y-4">
        <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-red-100">
          <svg
            className="w-8 h-8 text-red-600"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={2}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </div>

        <h1 className="text-2xl font-bold text-gray-900">Consent Failed</h1>
        <p className="text-sm text-gray-500">
          The consent creation could not be completed.
        </p>

        <div className="mt-4 bg-red-50 rounded-lg p-4">
          <p className="text-sm text-red-700">{reason}</p>
        </div>
      </div>

      <div className="flex justify-center gap-4">
        <Link
          to="/banks"
          className="rounded-lg bg-primary-600 px-4 py-2 text-sm font-medium text-white hover:bg-primary-700 transition-colors"
        >
          Try Again
        </Link>
        <Link
          to="/"
          className="rounded-lg border border-gray-300 px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 transition-colors"
        >
          Go Home
        </Link>
      </div>
    </div>
  );
}
